/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/common/tab-panel/tab-panel');
require('components/base/drop-menu/drop-menu');
require('components/base/icon/icon');
const tip = require('components/base/pop/tip');

require('appUtil/ajaxSetting');
const ajaxHttp = require('appUtil/ajaxHttp');
const store = require('appVuex/store');

const { apiPath } = require('appService/api');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent, common: searchToolEvent } = require('components/config/event.json');
const { setBreadCrumb } = require('src/common/vuex/action/common');

const template = require('./site-lists.tpl');
require('./site-lists.scss');
require('./city');

const siteLists = {
  template,
  store,

  vuex: {
    actions: {
	   setBreadCrumb,
    },
    getters: {
      authorityBtnList(state) {
        return state.authorityBtn.authorityBtnList;
      }
    }
  },
  
  data() {
  	return {
  	  thItems: ["站点名称","省","市","地址", "站点类型", "运营方","是否联网","车位数","枪头数","操作"],

  	  url: apiPath.charge.spotList,
  	  staUrl: apiPath.charge.statistics,
      pcdUrl: apiPath.common.selectPcd,

  	  siteItem:[
        {value: "-1", text: "站点类型"},
    		{value: "0", text: "个人"},
    		{value: "1", text: "公共"},
    		{value: "2", text: "运营"}
  	  ],
  	  netItem:[
    		{value: "-1", text: "联网状态"},
    		{value: "1", text: "已联网"},
    		{value: "0", text: "未联网"}
  	  ],
  	  statistics: {},
  	  spotType: "",
  	  netType: "",

      queryArgs: {
        "_size": 10,
        "_index": 1
      },

  	  tabItems: [
    		{text: "省份", name: "provinceList"},
    		{text: "城市", name: "cityList"}
      ],
      placeholder: "选择省市",
      citiesArr:[],
      provincesArr: [],
      pcdArrs: [],
      provinceText: "",
      cityText: "",
      pcdValue: "",
      pcdSearchEl: null,
      provinceId: "",
      cityId: "",
      top: null
  	}
  },

  ready() {

  	this.getPcdData();   //请求省市数据
  	this.getStatisticsData();  //请求统计数据
  	this.DOMEventBinding();   //DOM事件绑定
  },

  methods: {
  	_changesPcd(arr, name){
  	  let temp =[];
  	  for (let key in arr){
    		temp[key] = {};
    		temp[key].text = arr[key][name];
    		temp[key].value = arr[key].id;
    		temp[key].index = key;
  	  }
  	  return temp;
  	},
  	selectProvince(id, val){
  	  this.provinceId = val;
  	  this.tabItems[0].text = this.provincesArr[id].text; //选中省份，改变tab的值
  	  let _cities = this.pcdArrs[id].citys;
  	  let cities = [];
  	  cities = this._changesPcd(_cities,'cname');
  	  this.$set("citiesArr",cities);

  	  this.$refs.tabPanel.switchPanel(1); //切换tab
  	  this.provinceText = this.tabItems[0].text;
  	  this.pcdValue = `${this.provinceText}`;
  	  this.$refs.inputBox.value = this.pcdValue;
      // this.$refs.searchTool.search();
  	},
  	selectCity(id, val){
  	  this.cityId = val;
  	  this.tabItems[1].text = this.citiesArr[id].text;  //选中城市，改变tab的值

  	  // this.$refs.tabPanel.switchPanel(0);
  	  this.cityText = `-${this.tabItems[1].text}`;
  	  this.pcdValue = `${this.provinceText}${this.cityText}`;
  	  this.$refs.inputBox.value = this.pcdValue;
  	  // $(".province-city-warp").css("display","none"); //隐藏panel
      // this.$refs.searchTool.search();
  	},
  	getPcdData(){
  	  ajaxHttp(this.pcdUrl, {}).then((res) => {

    		if(res.code == 0){
    		  this.pcdArrs = res.data;
    		  let provinces = [];
    		  provinces = this._changesPcd(this.pcdArrs,'pname');
    		  this.$set("provincesArr",provinces);
    		}
  	  }).catch((res) => {
  		  // tip(res.error);
  	  });
  	},
  	getStatisticsData(){
  	  ajaxHttp(this.staUrl, {})
  	  .then((res) => {
  		if(res.code == 0){
  		  this.statistics = res.data;
  		}
  	  }).catch((res) => {
  		  // tip(res.error);
  	  });
  	},
  	DOMEventBinding(){
  	  const _self = this;

  	  $("html, body").on("mousedown", function(e){
    		const _length = $(".province-city-warp").find(e.target).length;
    		if (!_length){
    		  $(".province-city-warp").css({"display":"none", "top": _self.top});
    		}
  	  })

  	  $(".icon-stage").click(function(){
  		  $(".province-city-warp").css({"display":"none", "top": _self.top});
  	  })

  	  $(window).on("scroll",function(){
    		let offsetTop = $((_self.$refs.inputBox.$el)).offset().top;
    		let scrollTop = $(window).scrollTop();
    		_self.top = offsetTop - scrollTop + 40;
    		$(".province-city-warp").css({"top": _self.top});
  	  })

      $((_self.$refs.inputBox.$el)).on("click", function(){
        $(".province-city-warp").css({"top": _self.top});
      })
  	},
  	fetchQuery(queryOpt){
  	  let queryValue = queryOpt.queryValue;
      let fetchOpt = Object.assign({}, this.queryArgs);

      if (queryValue['spotType'] !== "-1"){
        Object.assign(fetchOpt, {"spotType": parseInt(queryValue['spotType'])});
      } else {
        delete fetchOpt.spotType;
      }

      if (queryValue['netType'] !== "-1"){
        Object.assign(fetchOpt, {"netType": parseInt(queryValue['netType'])});
      } else {
        delete fetchOpt.netType;
      }

      if (this.provinceId){
        Object.assign(fetchOpt, {"province": parseInt(this.provinceId)});
        if (this.cityId){
          Object.assign(fetchOpt, {"city": parseInt(this.cityId)});
        } else {
          delete fetchOpt.city;
        }
      } else {
        delete fetchOpt.province;
      }

      if (queryValue['keyWord']){
        Object.assign(fetchOpt, {"keyword": queryValue['keyWord']});
      } else {
        delete fetchOpt.searchKey;
      }
  	  this.$refs.tableData.query(fetchOpt).fetch();
  	},
    addComment(id){
      this.$route.router.go({
        path:"/page/charge/siteLists/detail/comment",
        query: {"spotID": id}
      })
    },
    clearPcd() {
      this.pcdValue = "";  //清空输入框内容
      this.provinceId = "";
      this.cityId = "";
      this.provinceText = "";
      this.cityText = "";
      this.$refs.inputBox.value = "";
      this.tabItems[0].text = "省份";
      this.tabItems[1].text = "城市"; 
      this.$refs.tabPanel.switchPanel(0); //切换回第一个tab
      this.citiesArr = null;  //城市清空
      $(".province-city-warp").css("display","none"); //隐藏panel
      // this.$refs.searchTool.search();
    }
  },
  events:{
  	[inputBoxEvent.focus](val){
  	  if (val.dispatcher.queryName == "pcdSearch"){
    		let offset = $((this.$refs.inputBox.$el)).offset();
    		let left = offset.left;
    		let top = offset.top + 40;

    		$(".province-city-warp").css({"display":"block", left: left, top: top});
    		this.$refs.inputBox.value = this.pcdValue;
  	  }
  	},
  	[inputBoxEvent.change](val){
  	  if (this.$refs.inputBox.value == ""){
  	    this.clearPcd();
  	  }
  	},
  },
  filters: {
    filterType(type) {
  	  let typeList = {
    		"0": "个人",
    		"1": "公共",
    		"2": "运营"
  	  }
  	  return typeList[type]
    },
    filterOperator(type){
  	  let operatorType = {
    		"100": "中创网",
    		"200": "星星充电",
    		"300": "个人",
    		"400": "运营"
  	  }
      return (operatorType[type] ? operatorType[type] : "中创网")
    },
    filterNetType(type){
      let netType = {
        "0": "未",
        "1": "是"
      }
	   return netType[type]
    }
  },
  route: {
    deactivate: function () {
  	  $(window).off("scroll");  //跳转前解绑
	    $("html, body").off("mousedown");
    }
  }
}
module.exports = siteLists;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/charge/site-lists/site-lists.js